// The ?redirect= parameter ends up in history.push(), so only an in-app path is safe to use.
// Anything else is dropped and the caller falls back to the account's default landing page:
// '//host' and '/\host' are protocol relative URLs that point off-site (and get blocked by
// the browser when they are not a valid URL, as with a bare '//'), and '/' would just bounce
// back to the layout that sent us to the login page in the first place.
export function sanitizeRedirect(redirect) {
    if (typeof redirect !== 'string') {
        return ''
    }

    const path = redirect.trim()

    if (!path.startsWith('/') || path.startsWith('//') || path.startsWith('/\\') || path === '/') {
        return ''
    }

    return path
}
